import React from "react";

const TabContext = React.createContext();

function Tab({ children }) {
  const [activeTab, setActiveTab] = React.useState(1);

  const setTab = (tab) => {
    setActiveTab(tab);
  };

  return (
    <TabContext.Provider value={{ activeTab, setTab }}>
      <div className="mt-4">{children}</div>
    </TabContext.Provider>
  );
}

function TabSwitcher({ children, tabId, activeClass = "bg-danger border-0" }) {
  const { activeTab, setTab } = React.useContext(TabContext);

  const onClick = () => setTab(tabId);

  const className = ["mr-2 p-2 btn-secondary border-0 rounded"];
  if (activeTab === tabId) className.push(activeClass);
  return (
    <button className={className.join(" ")} onClick={onClick}>
      {children}
    </button>
  );
}

function TabContent({ children, id }) {
  const { activeTab } = React.useContext(TabContext);
  return id === activeTab ? children : null;
}

export { Tab, TabSwitcher, TabContent };
